/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import ButtonIcon from 'DesignSystem/ButtonIcon/index'
import Label from 'DesignSystem/Label/index'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import XIcon from 'DesignSystem/Svgs/XIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CloseAction({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/More/Cancel/Content/CloseAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
  return (<React.Fragment
>
<ButtonIcon
  viewPath={`${viewPath}/ButtonIcon`}
 marginLeft={dtSpaceXxs}
 paddingTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../No'))}
>
{childProps => (
<div
  data-testid="CloseAction.Vertical"
  data-view-path={viewPath}
 style={{'--w-1-1xAYKG': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--mt-2-1xAYKG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<XIcon
  viewPath={`${viewPath}/XIcon`}
/>
<Label
  viewPath={`${viewPath}/Label`}
 marginTop={dtSpaceXxs}
 text="ESC"
/>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="esc"
 onPress={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../No'))}
/>
</div>
)}
</ButtonIcon>
{children}
</React.Fragment>)
}